import React, {useContext} from 'react'
import {Switch, Route, Redirect} from 'react-router-dom'
import {AudioPlayerProvider} from 'react-use-audio-player'
import './css/App.css'

import {PlayerStatsContext} from './context/PlayerStatsContext'
import {UnmountContextProvider} from './context/UnmountContext'
import {BackgroundMusicProvider} from './context/BackgroundMusicContext'
import {PuzzleChangeProvider} from './context/PuzzleChangeContext'

import LoginPage from './pages/loginPage/LoginPage'
import LandingPage from './pages/landingPage/LandingPage'
import LocationPage from './pages/locationPage/LocationPage'
import MapPage from './pages/mapPage/MapPage'
import StoryPage from './pages/StoryPage'

function App() {
    const {authorised} = useContext(PlayerStatsContext)
    
    return (
        <BackgroundMusicProvider>
            <Switch>
                <Route exact path="/">
                    <LoginPage />
                </Route>
                <Route path="/landing">
                    {authorised ? <LandingPage /> : <Redirect to='/' />}
                </Route>
                <Route path="/map">
                    {authorised ? <MapPage /> : <Redirect to='/' />}
                </Route>    
                <Route exact path="/location/:locationId/story">
                    <AudioPlayerProvider>
                        {authorised ? <StoryPage /> : <Redirect to='/' />}
                    </AudioPlayerProvider>
                </Route>
                <Route exact path="/location/:locationId/investigate">
                    <PuzzleChangeProvider>
                        <UnmountContextProvider>
                            {authorised ? <LocationPage />  : <Redirect to='/' />}
                        </UnmountContextProvider>
                    </PuzzleChangeProvider>
                </Route>
            </Switch>
        </BackgroundMusicProvider>
    )
}

export default App
